<template>
  <v-card flat>
    <v-card-title v-if="isSeparating && !showNewItemArea" class="mt-n6 mb-10">
      <v-row>
        <v-col class="text-end">
          <FormButton
            type="primario"
            @click="toggleNewItemArea"
            :disabled="!isSeparating || pedido.id_pedido_erp"
          >
            <v-icon>mdi-plus</v-icon> Adicionar novo item
          </FormButton>
          <v-tooltip top v-if="!isSeparating || pedido.id_pedido_erp">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" class="ml-3">far fa-question-circle</v-icon>
            </template>
            O pedido está sendo enviado para o seu ERP. <br />
            Confira no painel de detalhes os registros da sua integração e/ou no
            seu ERP. <br />Caso haja críticas ao pedido, avalie-as para que a
            sua integração ao ERP seja concluída. <br />
            Uma vez que o pedido esteja criado no seu ERP, toda edição deve ser
            feita por ele.
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text
      v-if="isSeparating && !pedido.id_pedido_erp && showNewItemArea"
      class="mt-n6 mb-n2"
    >
      <v-row>
        <v-col>
          <FormTags
            :placeholder="'Pesquise e selecione o produto'"
            :label="'Produto'"
            v-model="selectedProduct"
            :endpoint="endpointProdutos"
            queryname="filter"
            :searchWithSpaces="true"
            keyid="id_produto_erp"
            keyvalue="text"
            :multiple="false"
            :clearable="true"
          >
            <template v-slot:item="{ item }">
              <div class="d-flex flex-column align-start">
                <p style="margin-bottom:0!important">{{ item.nome }}</p>
                <small v-if="item.id_produto_erp"
                  >Cód. interno: {{ item.id_produto_erp }}</small
                >
                <small v-if="item.codigobarras"
                  >Cód. barras:{{ item.codigobarras }}</small
                >
              </div>
            </template>
          </FormTags>
        </v-col>
        <v-col cols="auto">
          <FormButton @click="addItem" type="success">
            Adicionar
          </FormButton>
          <FormButton class="ml-3" type="error" @click="cancelAddItem">
            Cancelar
          </FormButton>
        </v-col>
      </v-row>
    </v-card-text>
    <v-simple-table dense class="elevation-1 mt-3 margin-print">
      <thead>
        <tr>
          <th v-if="isSeparating && isEditable"></th>
          <th>Item</th>
          <th class="text-center">Quantidade</th>
          <th class="text-center" v-if="displayPrice">Preço</th>
          <th class="text-center" v-if="displayPrice">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <template v-if="item.idcadastroextrabase">
            <td v-if="isSeparating && !pedido.id_pedido_erp"></td>
            <td class="text-start" style="max-width: 200px;">
              <v-row no-gutters class="d-flex align-center py-1 ml-10 pl-5">
                <v-col cols="auto">
                  <img
                    v-if="
                      item.idcadastroextra &&
                        config.s3 &&
                        config.s3.bucketRoot &&
                        !item.errorImg
                    "
                    :src="urlImgItem(item.idcadastroextra)"
                    class="img-item mr-3"
                    @error="handleErrorImg(item)"
                  />
                  <img v-else class="img-item mr-3" src="@/assets/box.png" />
                </v-col>
                <v-col class="itens-nome grey--text">
                  <p class="mb-0 font-weight-bold">
                    {{ item.nome || item.nome_combo }}
                  </p>
                  <p class="mb-n1">
                    <small>
                      <span class="font-weight-bold">Cod. de barras: </span>
                      {{ item.codigobarras }}
                    </small>
                  </p>
                  <p class="mb-n1">
                    <small>
                      <span class="font-weight-bold">Cód. interno: </span>
                      {{ item.id_erp }}
                    </small>
                  </p>
                  <p class="mb-n1">
                    <small v-if="item.modificado">Editado</small>
                  </p>
                </v-col>
              </v-row>
            </td>
            <td class="text-center grey--text">
              {{ item.quantidade }}
            </td>
            <td class="font-weight-bold grey--text" v-if="displayPrice">
              {{ item.preco | formatMoney }}
            </td>
            <td v-if="displayPrice"></td>
          </template>
          <template
            v-else-if="!item.idcadastroextrabase && !item.id_combo_item"
          >
            <td v-if="isSeparating && !pedido.id_pedido_erp">
              <FormButtonMenu
                icon
                :options="tableOptions"
                @click="op => selectOption(item, op)"
              >
                <v-icon color="red" size="18">fa-trash</v-icon>
              </FormButtonMenu>
            </td>
            <td class="text-start">
              <v-row no-gutters class="d-flex align-center py-1">
                <v-col cols="auto">
                  <img
                    v-if="
                      item.idcadastroextra &&
                        config.s3 &&
                        config.s3.bucketRoot &&
                        !item.errorImg
                    "
                    :src="urlImgItem(item.idcadastroextra)"
                    class="img-item mr-3"
                    @error="handleErrorImg(item)"
                  />
                  <img v-else class="img-item mr-3" src="@/assets/box.png" />
                </v-col>
                <v-col class="itens-nome">
                  <p class="mb-n1 font-weight-bold">
                    {{ item.nome || item.nome_combo }}
                  </p>
                  <p class="mb-n1">
                    <small>
                      <span class="font-weight-bold">Cod. de barras: </span>
                      {{ item.codigobarras }}
                    </small>
                  </p>
                  <p class="mb-n1">
                    <small>
                      <span class="font-weight-bold">Cód. interno: </span>
                      {{ item.id_erp }}
                    </small>
                  </p>
                  <p class="mb-n1">
                    <small v-if="item.modificado">Editado</small>
                  </p>
                </v-col>
              </v-row>
            </td>
            <td class="text-center" width="200px">
              <FormField
                v-if="isEditable && showPrint"
                v-model.number="item.quantidade"
                typeField="number"
                class="text-center mb-n5 mt-2"
                @blur="updateItem(item)"
                :disabled="isLoading"
              ></FormField>
              <span v-else>{{ item.quantidade }}</span>
            </td>
            <td v-if="displayPrice">
              <FormField
                v-if="isEditable && config.podeEditarPreco"
                v-model.number="item.preco"
                typeField="number"
                class="text-center mb-n5 mt-2"
                @blur="updateItem(item)"
                :disabled="isLoading"
              ></FormField>
              <span v-else>{{ item.preco | formatMoney }}</span>
            </td>
            <td class="font-weight-bold" v-if="displayPrice">
              {{ (item.preco * item.quantidade) | formatMoney }}
            </td>
          </template>
        </tr>
      </tbody>
      <tbody v-for="item in itemsCombo" :key="item.id">
        <tr>
          <td v-if="isSeparating && !pedido.id_pedido_erp">
            <FormButtonMenu
              icon
              :options="tableOptions"
              @click="op => selectOption(item, op)"
            >
              <v-icon color="red" size="18">fa-trash</v-icon>
            </FormButtonMenu>
          </td>
          <td class="text-start">
            <v-row no-gutters class="d-flex align-center py-2">
              <v-col cols="auto">
                <img
                  v-if="
                    item.idcombopromocional_cabecalho &&
                      config.s3 &&
                      config.s3.bucketRoot &&
                      !item.errorImg
                  "
                  :src="urlImgItem(item.idcombopromocional_cabecalho)"
                  class="img-item mr-3"
                  @error="handleErrorImg(item)"
                />
                <img v-else class="img-item mr-3" src="@/assets/box.png" />
              </v-col>
              <v-col class="itens-nome">
                <p class="mb-0 font-weight-bold">
                  {{ item.nome || item.nome_combo }}
                </p>
                <p class="mb-n1">
                  <small>
                    <span class="font-weight-bold">Cod. de barras: </span>
                    {{ item.codigobarras }}
                  </small>
                </p>
                <p class="mb-n1">
                  <small>
                    <span class="font-weight-bold">Cód. interno: </span>
                    {{ item.id_erp }}
                  </small>
                </p>
                <p class="mb-n1">
                  <small v-if="item.modificado">Editado</small>
                </p>
              </v-col>
            </v-row>
          </td>
          <td class="text-center" width="200px">
            <FormField
              v-if="isEditable"
              v-model.number="item.quantidade"
              typeField="number"
              class="text-center mb-n5 mt-2"
              @blur="updateItem(item)"
              :disabled="isLoading"
            ></FormField>
            <span v-else>{{ item.quantidade }}</span>
          </td>
          <td v-if="displayPrice">
            <FormField
              v-if="isEditable && config.podeEditarPreco"
              v-model.number="item.preco"
              typeField="number"
              class="text-center mb-n5 mt-2"
              @blur="updateItem(item)"
              :disabled="isLoading"
            ></FormField>
            <span v-else>{{ item.preco | formatMoney }}</span>
          </td>
          <td class="font-weight-bold" v-if="displayPrice">
            {{ (item.preco * item.quantidade) | formatMoney }}
          </td>
        </tr>
        <tr v-for="subItem in item.produtos" :key="subItem.id">
          <td v-if="isSeparating && !pedido.id_pedido_erp"></td>
          <td class="text-start" style="max-width: 200px;">
            <v-row no-gutters class="d-flex align-center py-1 ml-10 pl-5">
              <v-col cols="auto">
                <img
                  v-if="
                    subItem.idcadastroextra &&
                      config.s3 &&
                      config.s3.bucketRoot &&
                      !subItem.errorImg
                  "
                  :src="urlImgItem(subItem.idcadastroextra)"
                  class="img-item mr-3"
                  @error="handleErrorImg(subItem)"
                />
                <img v-else class="img-item mr-3" src="@/assets/box.png" />
              </v-col>
              <v-col class="itens-nome grey--text">
                <p class="mb-0 font-weight-bold">
                  {{ subItem.nome || subItem.nome_combo }}
                </p>
                <p class="mb-n1">
                  <small>
                    <span class="font-weight-bold">Cod. de barras: </span>
                    {{ subItem.codigobarras }}
                  </small>
                </p>
                <p class="mb-n1">
                  <small>
                    <span class="font-weight-bold">Cód. interno: </span>
                    {{ subItem.id_erp }}
                  </small>
                </p>
                <p class="mb-n1">
                  <small v-if="subItem.modificado">Editado</small>
                </p>
              </v-col>
            </v-row>
          </td>
          <td class="text-center grey--text">
            {{ subItem.quantidade }}
          </td>
          <td class="font-weight-bold grey--text" v-if="displayPrice">
            {{ subItem.preco | formatMoney }}
          </td>
          <td v-if="displayPrice"></td>
        </tr>
      </tbody>
    </v-simple-table>
    <div
      v-if="items.length === 0 && itemsCombo.length === 0"
      class="text-center mt-2"
    >
      Itens cortados ou pedido com restrição
    </div>
    <v-card-text class="text-right" v-if="displayPrice">
      <v-row class="px-4 mb-n3 margin-print">
        <v-col class="font-weight-bold">Total em compras:</v-col>
        <v-col class="text-right" cols="3">
          {{ pedido.totalpedido | formatMoney }}
        </v-col>
      </v-row>
      <v-row class="px-4 mb-n3 margin-print">
        <v-col class="font-weight-bold">Taxas:</v-col>
        <v-col class="text-right" cols="3">
          {{ pedido.taxaentrega | formatMoney }}
        </v-col>
      </v-row>
      <v-row class="px-4 mb-n3 margin-print" v-if="pedido.totaldescontocupom">
        <v-col class="font-weight-bold">Descontos:</v-col>
        <v-col class="text-right" cols="3">
          {{ pedido.totaldescontocupom | formatMoney }}
        </v-col>
      </v-row>
      <v-row class="px-4 margin-print">
        <v-col class="font-weight-bold">Total à pagar:</v-col>
        <v-col class="text-right" cols="3">
          {{ pedido.totalliquido | formatMoney }}
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import OrderStatus from "../../../../utils/orderStatus";
import FormButton from "@/components/form/FormButton";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import FormField from "@/components/form/FormField";
import FormTags from "@/components/form/FormTags";
import { mapGetters } from "vuex";
import {
  PEDIDO_CONFIG,
  PEDIDO_INSERT_PRODUCT,
  PEDIDO_DELETE_PRODUCT,
  PEDIDO_UPDATE_PRODUCT
} from "@/store/actions/pedido";
import { formatarCombos } from "../../../../utils/combo";

export default {
  components: {
    FormButtonMenu,
    FormButton,
    FormField,
    FormTags
  },
  data() {
    return {
      isLoading: false,
      selectedProduct: null,
      showNewItemArea: false,
      config: {},
      items: [],
      itemsCombo: [],
      tableOptions: [
        { text: "Remover do pedido", value: "removeOrder" },
        {
          text: "Remover e indisponibilizar produto",
          value: "removeAndUnavailable"
        }
      ]
    };
  },
  props: {
    pedido: {
      type: Object,
      required: true
    },
    showPrint: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(["getFornecedorId"]),
    endpointProdutos() {
      return `/api/v1/produtos/s2format-simple?idfornecedor=${this.getFornecedorId}`;
    },
    isEditable() {
      const status = [
        OrderStatus.OrderStatus.ORCAMENTO_NOVO,
        OrderStatus.OrderStatus.ORCAMENTO_PRECIFICADO,
        OrderStatus.OrderStatus.ENVIADO,
        OrderStatus.OrderStatus.SEPARANDO
      ];
      return (
        status.indexOf(this.pedido.statuspedido) >= 0 &&
        !this.pedido.id_pedido_erp
      );
    },
    displayPrice() {
      const status = [OrderStatus.OrderStatus.ORCAMENTO_NOVO];
      return !(status.indexOf(this.pedido.statuspedido) >= 0);
    },
    isSeparating() {
      const status = [OrderStatus.OrderStatus.SEPARANDO];
      return status.indexOf(this.pedido.statuspedido) >= 0;
    }
  },
  methods: {
    getConfig() {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_CONFIG)
        .then(data => {
          this.config = data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    handleErrorImg(item) {
      this.$set(item, "errorImg", true);
    },
    urlImgItem(idcadastroextra) {
      return `${this.config.s3.bucketRoot}/shared/product-image/${idcadastroextra}.webp`;
    },
    toggleNewItemArea() {
      if (!this.isSeparating || this.pedido.id_pedido_erp) {
        return;
      }
      this.showNewItemArea = true;
    },
    addItem() {
      if (!this.selectedProduct) {
        this.$vueOnToast.pop("error", "Nenhum produto selecionado");
        return;
      }
      const data = {
        idproduto: this.selectedProduct.idproduto,
        numpedido: this.pedido.numpedido
      };
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_INSERT_PRODUCT, data)
        .then(() => {
          this.$vueOnToast.pop("success", "Produto adicionado com sucesso");
          this.isLoading = false;
          setTimeout(() => location.reload(), 1500);
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao adicionar produto");
          this.isLoading = false;
        });
    },
    cancelAddItem() {
      this.selectedProduct = {};
      this.showNewItemArea = false;
    },
    updateItem(item) {
      if (item.quantidade <= 0) {
        item.quantidade = 1;
      }
      if (item.preco <= 0) {
        item.preco = 1;
      }
      const data = {
        ...item,
        numpedido: this.pedido.numpedido
      };
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_UPDATE_PRODUCT, data)
        .then(() => {
          this.$emit("realod-order", this.pedido.numpedido);
          setTimeout(
            () =>
              this.$vueOnToast.pop("success", "Produto atualizado com sucesso"),
            1500
          );
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Falha ao atualizar o produto";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    selectOption(item, option) {
      switch (option.value) {
        case "removeOrder":
          return this.removeItem(item.id, false);
        case "removeAndUnavailable":
          return this.removeItem(item.id, true);
      }
    },
    removeItem(itemId, indisponivel) {
      const data = {
        itemid: itemId,
        numpedido: this.pedido.numpedido,
        indisponivel
      };
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_DELETE_PRODUCT, data)
        .then(() => {
          this.$vueOnToast.pop("success", "Produto removido com sucesso");
          this.isLoading = false;
          setTimeout(() => location.reload(), 1500);
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Falha ao remover o produto";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    }
  },
  created() {
    const itens =
      this.pedido.dadospedido && this.pedido.dadospedido.itens
        ? this.pedido.dadospedido.itens
        : [];
    this.items = itens
      .map(i => {
        return {
          ...i,
          errorImg: false
        };
      })
      .filter(i => !i.deleted);

    if (this.pedido.dadospedido && this.pedido.dadospedido.itensFormatCombo) {
      this.itemsCombo = formatarCombos(
        this.pedido.dadospedido.itensFormatCombo,
        itens
      );
    }

    this.getConfig();
  }
};
</script>

<style>
.img-item {
  max-width: 40px;
}
</style>
